module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-5.d51b10f9.mp3";